export type AnswerEffectResult = 'correct' | 'wrong' | null;

function CognitiveAnswerEffect({ result, language = 'ko' }: { result: AnswerEffectResult; language?: string }) {
  if (!result) return null;
  const correct = result === 'correct';
  const label = language === 'ko' ? (correct ? '정답' : '오답') : (correct ? 'Correct' : 'Wrong');
  return (
    <div className={`cognitive-answer-effect ${result}`} role="status" aria-live="assertive" aria-label={label}>
      <strong className="cognitive-answer-effect__mark" aria-hidden="true">{correct ? 'O' : 'X'}</strong>
    </div>
  );
}

export default CognitiveAnswerEffect;
